import axios from "axios"
import { toast } from "react-toastify"
import { mainurl } from "./mainurl"
import { jobPostAllFail, jobPostAllLoading, jobPostAllSuccess, jobPostCreateFail, jobPostCreateLoading, jobPostCreateSuccess, jobPostDeleteFail, jobPostDeleteLoading, jobPostDeleteSuccess } from "../slices/jobPostSlice"
import { carrerAllFail, carrerAllLoading, carrerAllSuccess } from "../slices/careerSlice"


const baseurl = mainurl

export const CreateJobPosts = (jobpostdata) => async (dispatch) => {

    console.log(...jobpostdata);

    try {
        dispatch(jobPostCreateLoading())
        const { data } = await axios.post(`${baseurl}/jobpost/newjobpost`, jobpostdata, { withCredentials: true })
        dispatch(jobPostCreateSuccess(data))
        toast.success("Job post created successfully")

    } catch (error) {

        dispatch(jobPostCreateFail(error.response.data.message));
        toast.error(error.response.data.message,)
    }
}



export const Alljobpost = async (dispatch) => {
    try {
        dispatch(jobPostAllLoading())
        const { data } = await axios.get(`${baseurl}/jobpost/getjobpost`, { withCredentials: true })
        console.log(data);
        dispatch(jobPostAllSuccess(data));
    } catch (error) {
        dispatch(jobPostAllFail(error.response.data.message))
    }
}

export const getDeleteJobPost = (id) => async (dispatch) => {
    try {
        dispatch(jobPostDeleteLoading())
        const { data } = await axios.delete(`${baseurl}/jobpost/delete-job/${id}`, { withCredentials: true })
        dispatch(jobPostDeleteSuccess(data.deletejob))
        toast.success("delete successfully")
    } catch (error) {
        dispatch(jobPostDeleteFail(error.response.data.message));
        toast.error(error.response.data.message,)

    }

}



export const getAllcareer = async (dispatch) => {
    try {
        dispatch(carrerAllLoading())
        const { data } = await axios.get(`${baseurl}/career/getcareer`, { withCredentials: true })
        console.log(data);
        dispatch(carrerAllSuccess(data));
    } catch (error) {
        dispatch(carrerAllFail(error.response.data.message))
    }
}